export default {
  shopTimes: [],
  shopTime: undefined,
};
